module.exports = __webpack_public_path__ + "static/media/p16.08c2806d.jpeg";